// Color utility functions for lesson types
// This maps background colors to their corresponding box-shadow colors from Timetable.css

const COLOR_SHADOWS = {
  '#02c2c7': '#00a2a7', // sky
  '#e95601': '#af4305', // orange  
  '#5bbd2a': '#4ca520', // green
  '#f0d001': '#dcbf02', // yellow
  '#ff48a4': '#e82d8b', // pink
  '#9d60ff': '#8343e8', // purple
  '#ff5722': '#d84213', // lightred
  '#a37437': '#dcbf02', // gold (no specific shadow in CSS, using yellow)
  '#795548': '#4c3027', // brown/chocolate - corrected shadow
  '#e53935': '#a71d1d', // red
  '#1e88e5': '#164c9d', // blue
  '#5c6bc0': '#343e8a', // indigo
  '#00acc1': '#007c8d', // cyan
  '#00897b': '#00655f', // teal
  '#c0ca33': '#7e8a12', // lime
  '#ffb300': '#b27800', // amber
  '#673ab7': '#4b248d', // deeppurple
  '#9e9e9e': '#616161', // gray
  '#c0c0c0': '#7d7d7d', // silver
  '#4fc3f7': '#2684b3', // lightblue
  '#2979ff': '#004ecb', // royalblue
  '#283593': '#101a52', // navy
  '#81d4fa': '#35a2d1', // skyblue
  '#f8bbd0': '#d47aa6', // lightpink
  '#ff4081': '#c60055', // hotpink
  '#d81b60': '#8a0032', // deeppink
  '#e91e63': '#ad0040', // magenta
  '#d2b48c': '#a08866', // tan
  '#a0522d': '#6f381e', // sienna
  '#5d4037': '#35251d', // darkbrown
};

/**
 * Get the complete style object for a lesson type including background color and box shadow
 * @param {string} backgroundColor - The hex color value
 * @param {boolean} includeBoxShadow - Whether to include the box shadow (default: false)
 * @returns {object} Style object with backgroundColor and boxShadow
 */
export const getLessonTypeStyle = (backgroundColor, includeBoxShadow = false) => {
  const style = {
    backgroundColor: backgroundColor || '#02c2c7', // fallback to sky color
  };
  
  if (includeBoxShadow && backgroundColor && COLOR_SHADOWS[backgroundColor]) {
    style.boxShadow = `0px 5px 0px 0px ${COLOR_SHADOWS[backgroundColor]}`;
  }
  
  return style;
};

/**
 * Get just the shadow color for a given background color
 * @param {string} backgroundColor - The hex color value
 * @returns {string|null} The shadow color or null if not found
 */
export const getShadowColor = (backgroundColor) => {
  return COLOR_SHADOWS[backgroundColor] || null;
};